import React, { Component } from "react";
import * as $ from "jquery";

import "!!style-loader!css-loader!datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net";
import "datatables.net-bs4";
import "datatables.net-select";
import sha1 from "js-sha1";

import {
  logoImage,
  logoColumn,
  logoVersionTable,
  modalBody
} from "./BrandSearchModal.css";
import DataService from "./DataService";

export default class BrandSearchModal extends Component {
  async componentDidMount() {
    const { el } = this;
    const logoVersions = await DataService.getBrandsAndLogoVersions();

    el.on("shown.bs.modal", e => {
      // focus on the search box
      el.find("#table_id_filter input").focus();

      // Init only once
      if (this.dataTable) {
        return;
      }

      this.dataTable = el.find("table").DataTable({
        scrollY: "50vh",
        scrollCollapse: false,
        search: {
          regex: false,
          smart: true
        },
        pageLength: 50,
        deferRender: true,
        data: logoVersions,
        initComplete: function() {
          // focus on the search box, I do it here again because field does not exist pre initialisation
          el.find("#table_id_filter input").focus();
        },
        columns: [
          { data: "brandName", title: "Brand" },
          {
            data: "logoVersionIds",
            title: "Logo Version",
            render: (logoVersionIds, type, full, meta) => {
              return logoVersionIds
                .split(",")
                .map(
                  logoVersionId =>
                    `<img class=${logoImage} src="` +
                    this.getThumbUrl(logoVersionId) +
                    '"/>'
                )
                .join("");
            },
            className: `${logoColumn}`,
            orderable: false,
            searchable: false
          }
        ],
        select: {
          info: false,
          style: "single"
        },
        drawCallback: () => {
          el.find('table tr').off('dblclick').dblclick((e) => {
            var selectedRow = this.dataTable.row(e.currentTarget).data();
            this.onBrandSelect(selectedRow);
          });
        }
      });
    });
  }

  getThumbUrl(logoVersionId) {
    let extension = ".png",
      filekey = `logograb/cache-dir-local/logo-version/${logoVersionId}/thumb${extension}`;

    return `https://s3-eu-west-1.amazonaws.com/s3.logograb.com/logograb/cache-dir-public/${sha1(
      filekey
    )}${extension}`;
  }

  onBrandSelect(selectedRow) {
    const { onBrandSelect } = this.props;

    // Retrieve selected row when Select button is clicked
    if (selectedRow === undefined) {
      selectedRow = this.dataTable.rows({ selected: true }).data()[0];
    }

    this.el.modal("hide");

    onBrandSelect(selectedRow.brandId);
  }

  render() {
    return (
      <div
        className="modal fade"
        id="lgLogoSearchModal"
        tabIndex={-1}
        role="dialog"
        ref={el => (this.el = $(el))}
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="myModalLabel">
                Brands
              </h4>
            </div>
            <div className={`${modalBody} modal-body`}>
              <table
                id="table_id"
                className={`table table-bordered table-striped ${logoVersionTable} table-hover`}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.onBrandSelect()}
                ng-disabled="!vm.selectEnabled"
              >
                Select
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/BrandSearchModal.js